import { useQuery } from '@tanstack/react-query';
import { fidelizadorFeaturesQuery } from '@/api/fidelizador';
import { type NavItem, tenantGroupItems } from './nav-config';

/**
 * Ítems del grupo TENANT visibles ahora: los que exigen un interruptor `fidelizador.*` solo aparecen si está contratado y encendido
 * para el tenant actual (mientras carga, o si la consulta falla, quedan ocultos; la ruta directa sigue explicando cómo habilitarlos).
 */
export function useTenantNavItems(isPlatformAdmin: boolean, tenantId: string | null): readonly NavItem[] {
  const items = tenantGroupItems(isPlatformAdmin);
  const needsFeatures = items.some((i) => i.requiresFeature);
  const features = useQuery({
    ...fidelizadorFeaturesQuery(tenantId ?? ''),
    enabled: needsFeatures && tenantId !== null,
    retry: false,
  });
  const active = new Set((features.data ?? []).filter((f) => f.contractStatus === 'active').map((f) => f.code));
  return items.filter((i) => !i.requiresFeature || active.has(i.requiresFeature));
}
